module.exports = __webpack_public_path__ + "static/img/wap_signin_logo_hy.249acd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/wap_signin_logo_hy.png
// module id = Fs2W
// module chunks = 1